(function () {
  'use strict';

  var MEDIA_SELECTOR = 'img, picture, video, iframe, model-viewer, .video-container, .product-video';
  var UNSAFE_SPLIT_SELECTOR = 'table, form, details, summary, script, style';

  function cleanText(element) {
    return (element.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function containsMedia(element) {
    return element.matches(MEDIA_SELECTOR) || Boolean(element.querySelector(MEDIA_SELECTOR));
  }

  function isMediaOnlyRow(element) {
    if (!containsMedia(element) || element.matches(UNSAFE_SPLIT_SELECTOR)) return false;

    var textLength = cleanText(element).length;
    var mediaCount = element.matches(MEDIA_SELECTOR) ? 1 : element.querySelectorAll(MEDIA_SELECTOR).length;
    var controlCount = element.querySelectorAll('button, input, select, textarea').length;

    return mediaCount > 0 && controlCount === 0 && textLength <= 120;
  }

  function createMediaRow(node) {
    if (node.nodeType === Node.ELEMENT_NODE && !node.matches('img, picture, video, iframe, model-viewer')) {
      node.classList.add('iine-product-story__media-row');
      return node;
    }

    var row = document.createElement('div');
    row.className = 'iine-product-story__media-row';
    row.appendChild(node);
    return row;
  }

  function addResponsiveShopifySources(image) {
    if (image.hasAttribute('srcset')) return;
    var source = image.getAttribute('src');
    if (!source) return;

    var url;
    try {
      url = new URL(source, document.baseURI);
    } catch (error) {
      return;
    }

    var isShopifyImage = url.hostname === 'cdn.shopify.com' || url.pathname.indexOf('/cdn/shop/') !== -1 || url.pathname.indexOf('/s/files/') !== -1;
    if (!isShopifyImage) return;

    var widths = [480, 750, 1000, 1500, 2000];
    var sources = widths.map(function (width) {
      var candidate = new URL(url.href);
      candidate.searchParams.set('width', width);
      return candidate.href + ' ' + width + 'w';
    });
    image.setAttribute('srcset', sources.join(', '));
    image.setAttribute('sizes', '(min-width: 1100px) 58vw, 100vw');
  }

  function prepareMedia(row) {
    row.querySelectorAll('img').forEach(function (image) {
      image.loading = 'lazy';
      image.decoding = 'async';
      image.fetchPriority = 'low';
      addResponsiveShopifySources(image);
    });

    row.querySelectorAll('iframe').forEach(function (frame) {
      frame.loading = 'lazy';
      if (!frame.title) frame.title = 'Product video';
    });

    row.querySelectorAll('video').forEach(function (video) {
      video.preload = video.preload || 'metadata';
    });
  }

  function extractMediaFrom(container, visualTarget) {
    Array.prototype.slice.call(container.children).forEach(function (child) {
      if (!child.isConnected || !containsMedia(child)) return;

      if (isMediaOnlyRow(child)) {
        var row = createMediaRow(child);
        prepareMedia(row);
        visualTarget.appendChild(row);
        return;
      }

      if (!child.matches(UNSAFE_SPLIT_SELECTOR)) {
        extractMediaFrom(child, visualTarget);
      }
    });
  }

  function hasReadableCopy(copy) {
    if (cleanText(copy).length > 2) return true;
    return Boolean(copy.querySelector('ul, ol, table, blockquote, button'));
  }

  function enhanceStory(story) {
    if (!story || story.dataset.iineProductStoryReady === 'true') return;

    var copy = story.querySelector('[data-iine-product-copy]');
    var copyShell = story.querySelector('[data-iine-product-copy-shell]');
    var visuals = story.querySelector('[data-iine-product-visuals]');
    var visualSection = story.querySelector('[data-iine-product-visual-section]');
    if (!copy || !copyShell || !visuals || !visualSection) return;

    story.dataset.iineProductStoryReady = 'true';

    if (story.dataset.separateMedia === 'true') {
      extractMediaFrom(copy, visuals);
    }

    if (visuals.children.length > 0) {
      visuals.hidden = false;
      visualSection.hidden = false;
    } else {
      visualSection.hidden = true;
    }

    if (!hasReadableCopy(copy)) {
      copyShell.hidden = true;
    }
  }

  function init(scope) {
    var root = scope || document;
    if (root.matches && root.matches('[data-iine-product-story]')) enhanceStory(root);
    root.querySelectorAll('[data-iine-product-story]').forEach(enhanceStory);
    initPurchaseScrollHandoff(root);
  }

  function normaliseWheelDelta(event, panel) {
    if (event.deltaMode === 1) return event.deltaY * 18;
    if (event.deltaMode === 2) return event.deltaY * panel.clientHeight;
    return event.deltaY;
  }

  function initPurchaseScrollHandoff(scope) {
    var selector = '.iine-product-page--enhanced.iine-product-page--split .product-column-right';
    var panels = [];

    if (scope.matches && scope.matches(selector)) panels.push(scope);
    scope.querySelectorAll(selector).forEach(function (panel) { panels.push(panel); });

    panels.forEach(function (panel) {
      if (panel.dataset.iineScrollHandoffReady === 'true') return;
      panel.dataset.iineScrollHandoffReady = 'true';

      panel.addEventListener('wheel', function (event) {
        if (window.innerWidth < 1200 || event.ctrlKey || event.deltaY === 0) return;

        var delta = normaliseWheelDelta(event, panel);
        var movingDown = delta > 0;
        var atTop = panel.scrollTop <= 1;
        var atBottom = panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 1;
        var panelCanScroll = movingDown ? !atBottom : !atTop;

        if (panelCanScroll) return;

        event.preventDefault();
        window.scrollBy({ top: delta, left: 0, behavior: 'auto' });
      }, { passive: false });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
